import { axiosService } from 'services';
import { Credentials, JwtTokens } from 'interfaces';
import { AXIOS_URLS } from 'config';

export const authService = {
  signIn: (credentials: Credentials): Promise<JwtTokens> =>
    axiosService
      .post(`${AXIOS_URLS.auth}/sign-in`, credentials)
      .then((res) => res.data),
  signUp: (credentials: Credentials): Promise<JwtTokens> =>
    axiosService
      .post(`${AXIOS_URLS.auth}/sign-up`, credentials)
      .then((res) => res.data),
  signOut: (refreshToken: string) =>
    axiosService
      .post(`${AXIOS_URLS.auth}/sign-out`, { refreshToken })
      .then((res) => res.data),
  refresh: () =>
    axiosService.post(`${AXIOS_URLS.auth}/refresh`).then((res) => res.data),
};
